export const getAdjustedPointSize = (pointSize, usePixelRatio) => {
  return usePixelRatio ? pointSize * (window.devicePixelRatio ** 2) : pointSize;
};